import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from '../auth.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthenticatedGuard implements CanActivate {
    constructor(private readonly authService: AuthService) {}

    canActivate(): boolean | Observable<boolean> {
        if (this.authService.isAuthenticated()) {
            return true;
        }

        // No refresh token — nothing to recover from, logout immediately
        if (!this.authService.getExistingRefreshToken()) {
            this.authService.logout();
            return false;
        }

        // Access token expired but refresh token exists.
        // getRefreshToken() is idempotent — if a refresh is already in flight
        // (e.g. scheduleTokenRefresh just fired) this returns the shared observable
        // instead of starting a second HTTP call. Wait for it before deciding.
        return this.authService.getRefreshToken().pipe(
            map(() => true),
            // getRefreshToken() has already logged out if the token was rejected
            catchError(() => of(false))
        );
    }

}
